import React from 'react';
import { Link } from 'react-router-dom';
import NewsletterSignup from '../components/NewsletterSignup';

const FounderStatement = ({ isPreview = false }) => {
  // Preview on Homepage
  if (isPreview) {
    return (
      <section className="portfolio-preview-section">
        <div className="container">
          <h2 className="section-title-centered">Founder's Statement</h2>
          <p className="portfolio-subtitle">
            ZIRAYA Institute emerged from questions encountered throughout work as an artist, researcher, producer, and advocate.
          </p>

          <div className="portfolio-preview-content">
            <div className="portfolio-cta" style={{ textAlign: 'center', width: '100%' }}>
              <Link to="/founder-statement" className="btn">Read Founder's Statement</Link>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Full Founder Statement page
  return (
    <>
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1>Founder's Statement</h1>
          <p className="hero-cta">Valentine Zikki — Founder, ZIRAYA Institute</p>
        </div>
      </section>

      {/* Founder Statement - Using same layout as ValentineZikkiPortfolio */}
      <section className="portfolio-full-section">
        <div className="container">
          {/* Top Row - Image Left, Text Right */}
          <div className="portfolio-top-row">
            {/* Left Column - Image */}
            <div className="portfolio-image-col">
              <div className="image-frame-large">
                <img
                  src="/images/valentine-zikki.jpg"
                  alt="Valentine Zikki, Founder of ZIRAYA Institute"
                  className="portfolio-image-full"
                />
              </div>
            </div>

            {/* Right Column - Opening Statement */}
            <div className="portfolio-statement-col">
              <h2 className="section-title-left">Founder's Statement</h2>
              <p className="statement-intro">
                ZIRAYA Institute emerged from questions I encountered repeatedly throughout my work as an artist, researcher, producer, and advocate.
              </p>
              <p>Across the creative sector, I met talented people navigating challenges that extended far beyond 
                artistic practice itself. Questions of sustainability, safety, inclusion, documentation, access, 
                and emerging technologies appeared again and again. Artists were creating extraordinary work, 
                yet many lacked the systems, support, and structures necessary to thrive.</p>

            
            </div>
          </div>

          {/* Full Statement Below */}
          <div className="portfolio-full-text">
            <p>At the same time, I became increasingly interested in the relationship between creativity, technology, and social change. I wanted to understand how artificial intelligence, neurodiversity, safeguarding, and cultural memory were shaping the future of creative work, particularly within African contexts.</p>

            <p>Rather than treating these issues as separate conversations, ZIRAYA Institute was created to explore the connections between them.</p>

            <p>Our work is driven by a belief that creative ecosystems flourish when people are safe, included, supported, and equipped to participate fully. Through research, advocacy, artistic experimentation, and public engagement, we seek to generate knowledge, develop practical tools, and contribute to healthier, more sustainable creative futures.</p>

            <p className="founder-conclusion-quote">ZIRAYA is ultimately a space for inquiry, collaboration, and action. A place where research informs practice, where creativity meets evidence, and where difficult questions can lead to meaningful change.</p>

            <p className="founder-signature">— Valentine Zikki</p>
            <p className="founder-title">Founder, ZIRAYA Institute</p>

            {/* Contact Email */}
            <div className="founder-contact">
              <i className="fas fa-envelope"></i>
              <a href="mailto:zikki@zirayainstitute.org">zikki@zirayainstitute.org</a>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Signup */}
      <NewsletterSignup variant="default" />
    </>
  );
};

export default FounderStatement;